export default {
  "": "",
  "24hChange": "Tăng giảm 24H",
  "24hTurnover": "Doanh thu 24H",
  "action": "Hoạt động",
  "AddLoan": "Tăng Lên",
  "AdjustLoanFail": "Không điều chỉnh được số tiền đảm bảo. Vui lòng thử lại sau. ",
  "all": "Tất cả",
  "apply": "Nộp",
  "assets": "Coin",
  "available": "Khả dụng",
  "balance": "Số dư khả dụng",
  "bi_all": "Tất Cả",
  "bi_average_change": "Biến Động Trung Bình 24H",
  "bi_down_amount": "Volume Giảm Sút",
  "bi_down_num": "Thua Lỗ",
  "bi_eth_gas": "Gas ETH",
  "bi_google_tips": "Các con số thể hiện mối quan tâm tìm kiếm một cụm từ trên Google so với điểm cao nhất trên biểu đồ cho khu vực và thời gian nhất định. Giá trị 100 là mức độ phổ biến cao nhất của cụm từ.",
  "bi_google_trends": "BTC trên Google Trends",
  "bi_market_cap": "Vốn Hóa Thị Trường Tiền Điện Tử Toàn Cầu (USDT)",
  "bi_market_distribution": "Phân Phối Vốn Hóa Thị Trường",
  "bi_market_sentiment": "Tâm Lý Thị Trường",
  "bi_market_trends": "Xu Hướng Thị Trường Tiền Điện Tử",
  "bi_market_volatility": "Biến Động Thị Trường Tiền Điện Tử",
  "bi_normal_amount": "Coin Không Thay Đổi Về Volume",
  "bi_normal_num": "Không Thay Đổi",
  "bi_page_title": "Theo Dõi Xu Hướng, Dự Đoán & Biến Động Thị Trường {'|'} Bybit",
  "bi_price_distribution": "Phân Phối Thay Đổi Giá",
  "bi_ranking": "Bảng Xếp Hạng",
  "bi_ranking_sector": "Vùng",
  "bi_ranking_tips": "Hiện chỉ hiển thị top 3 công ty theo vốn hóa thị trường của lĩnh vực này.",
  "bi_sentiment1": "Sợ Hãi Cực Độ",
  "bi_sentiment2": "Sợ Hãi",
  "bi_sentiment3": "Bình Thường",
  "bi_sentiment4": "Tham Lam",
  "bi_sentiment5": "Tham Lam Cực Độ",
  "bi_social": "Xu hướng trên Mạng Xã Hội",
  "bi_td_trade": "Giao Dịch",
  "bi_th_action": "Hoạt Động",
  "bi_th_change": "Biến Động 24H",
  "bi_th_currency": "Tiền Tệ",
  "bi_th_market": "Vốn Hóa Thị Trường",
  "bi_th_price": "Giá",
  "bi_th_sector": "Vùng",
  "bi_th_up_down": "Số Tăng Giá/Giảm Giá ",
  "bi_th_volume": "Khối Lượng Giao Dịch 24H",
  "bi_top_20": "Vốn Hóa Thị Trường",
  "bi_top_gain": "Top Tăng Giá (% Tăng)",
  "bi_total_market": "Tổng Vốn Hóa Thị Trường",
  "bi_trading_distribution": "Phân Phối Khối Lượng Giao Dịch",
  "bi_trading_vol": "Khối Lượng Giao Dịch Tiền Điện Tử Toàn Cầu 24H (USDT)",
  "bi_twitter_explore": "Khám Phá Twitter",
  "bi_twitter_tips1": "Các chủ đề mới nổi trên Twitter",
  "bi_twitter_tips2": "Các chủ đề thịnh hành trên Twitter",
  "bi_twitter_topics": "Các Chủ Đề Thịnh Hành Trên Twitter",
  "bi_up_amount": "Volume Tăng Giá",
  "bi_up_num": "Tăng Giá",
  "bi_view": "Lượt Xem",
  "bi_volume_distribution": "Phân Phối Thay Đổi Khối Lượng",
  "botValidateErrCode101": "Giá tối thiểu quá thấp",
  "botValidateErrCode102": "Giá tối thiểu quá cao",
  "botValidateErrCode103": "Giá tối đa quá thấp",
  "botValidateErrCode104": "Giá tối đa quá cao",
  "botValidateErrCode105": "Quá ít lưới",
  "botValidateErrCode106": "Quá nhiều lưới",
  "botValidateErrCode107": "Số tiền đầu tư quá thấp và không đáp ứng yêu cầu đầu tư",
  "botValidateErrCode108": "Số tiền đầu tư quá cao và vượt quá giới hạn đầu tư của hợp đồng",
  "botValidateErrCode109": "Giá chốt lời quá thấp",
  "botValidateErrCode110": "Giá chốt lời quá cao",
  "botValidateErrCode111": "Giá cắt lỗ quá thấp",
  "botValidateErrCode112": "Giá cắt lỗ quá cao",
  "botValidateErrCode113": "Giá vào lệnh quá thấp",
  "botValidateErrCode114": "Giá vào lệnh quá cao",
  "cancel": "Không",
  "cancelAll": "Hủy tất cả",
  "cancelOrder": "Hủy",
  "chart": "Chart",
  "close": "Đóng",
  "confirm": "Có",
  "contest-about-to-start": "Cho Đến Khi Cuộc Thi Bắt Đầu",
  "contest-accumulate-volume": "Khối Lượng Giao Dịch Tích Lũy",
  "contest-accumulate-volume-start": "Đăng ký thành công! Khối lượng giao dịch Giao Ngay sẽ được tính ngay bây giờ.",
  "contest-achieve-standards": "Đủ Điều Kiện",
  "contest-activity-rules": "Quy Tắc Sự Kiện",
  "contest-activity-rules-title": "Quy Tắc Hoạt Động",
  "contest-activity-time": "Thời Gian Sự Kiện",
  "contest-countdown": "Cho Đến Khi Cuộc Thi Kết Thúc",
  "contest-countdown-day": "NGÀY,",
  "contest-cumulative-volume": "Tổng Khối Lượng Giao Dịch ({unit})",
  "contest-current-volume": "Khối Lượng Giao Dịch Hiện Tại",
  "contest-date-range": "{time} {utc} vào {date} {month} ",
  "contest-dialog-btn-text": "Xác Nhận",
  "contest-difference-to-foward": "Cách {num} {unit} so với nhà giao dịch tiếp theo trong top",
  "contest-earn-rewards": "Nhận Được ({unit}) Phần Thưởng",
  "contest-ended": "Sự Kiện Đã Kết Thúc",
  "contest-find-more-premium-assets": "Giao dịch nhiều coin hơn trên nền tảng Giao Ngay!",
  "contest-latest-update": "Sẽ cập nhật dữ liệu lúc {time}{utc}.",
  "contest-less": "Ẩn Bớt",
  "contest-limit-desc": "Bạn cần đạt khối lượng giao dịch Giao Ngay tối thiểu để {amount} {unit} đủ điều kiện nhận thưởng.",
  "contest-list-show-more": "Xem Thêm",
  "contest-login": "Đăng Nhập",
  "contest-month": "tháng 1, tháng 2, tháng 3, tháng 4, tháng 5, tháng 6, tháng 7, tháng 8, tháng 9, tháng 10, tháng 11, tháng 12",
  "contest-my-rank": "Thứ Hạng Của Tôi",
  "contest-no-rank": "Chưa có thứ hạng. Chờ nhé!",
  "contest-no-rank-yet": "Chưa Có Thứ Hạng",
  "contest-not-registered": "Bạn đã không đăng ký tham gia cuộc thi giao dịch này.",
  "contest-num-of-participants": "Số Người Tham Gia",
  "contest-popup-success": "Giao Dịch Ngay",
  "contest-ranking": "Thứ Hạng",
  "contest-register": "Đăng Ký Ngay",
  "contest-registered": "Đã Đăng Ký",
  "contest-registration-ends": "Đóng Đăng Ký",
  "contest-rewards-earned": "Nhận Được ({unit}) Phần Thưởng",
  "contest-share": "Chia Sẻ",
  "contest-symbol-scope": "Cặp Giao Ngay",
  "contest-terms-conditions": "<p>Điều Khoản và Điều Kiện</p>",
  "contest-to-spot-trade": "Sự kiện đã bắt đầu. Nạp và giao dịch ngay!",
  "contest-u-earned-king": "Bạn đã giành được phần thưởng \"Nhà Giao Dịch Đỉnh Cao\"",
  "contest-u-earned-sunny": "Bạn đã giành được phần thưởng \"Nhà Giao Dịch Top\"",
  "contest-unqualified": "Rất tiếc, bạn không đủ điều kiện tham gia sự kiện. Nếu bạn có bất kỳ thắc mắc nào, vui lòng liên hệ với bộ phận hỗ trợ khách hàng.",
  "contest-updated-daily-at": "*Cập nhật gần nhất lúc {time} (giờ UTC).",
  "contest-will-start-tips": "Đăng ký thành công! Sự kiện sẽ bắt đầu lúc {time}. Hãy sẵn sàng!",
  "contest-your-rewards": "Phần thưởng đủ điều kiện của bạn",
  "contract_account": "tài khoản Phái Sinh",
  "createErrorCode400": "Dữ liệu do người dùng gửi có chứa các tham số bất hợp pháp. Vui lòng kiểm tra thông báo và chi tiết lỗi để biết thêm thông tin.",
  "createErrorCode401": "Số dư không đủ.",
  "createErrorCode402": "Số lượng bot do người dùng tạo đã đạt đến giới hạn.",
  "createErrorCode403": "CẤM",
  "createErrorCode404": "Không tìm thấy nguồn được yêu cầu.",
  "createErrorCode407": "Không hỗ trợ người dùng này tạop tài khoản phụ Grid Bot.",
  "createErrorCode408": "Đã chọn các mục tiêu đầu tư trùng lặp",
  "createErrorCode409": "Số tiền đầu tư tối đa không hợp lệ",
  "createErrorCode410": "Số tiền đầu tư tối đa không hợp lệ",
  "createErrorCode411": "Bot đã bị đóng",
  "createErrorCode412": "Tài Khoản Ký Quỹ Hợp Nhất đang được nâng cấp",
  "createErrorCode500": "Lỗi Máy Chủ Nội Bộ",
  "createErrorCode501": "Hết Thời Gian Chờ Nội Bộ",
  "createErrorCode503": "Bot DCA hiện không thể đóng và có thể đang trong quá trình thực hiện giao dịch mua",
  "currency": "Coin",
  "dailyRate": "Lãi Suất Hàng Ngày",
  "deposit": "Nạp tiền",
  "detail": "Chi tiết",
  "direction": "Hướng đặt lệnh",
  "end": "Thời Gian Kết Thúc",
  "fiat": "Fiat",
  "filled": "Đã khớp",
  "filter": "Bộ Lọc",
  "from": "Thời Gian Bắt Đầu",
  "global_setting_quick_order_desc": "<p>1. Lệnh Thị Trường (Đặt Lệnh Nhanh)</p>\n<p>2. Lưu ý, số lượng mua đã khớp của bạn có thể hơi khác so với số lượng lệnh bạn đã nhập.</p>",
  "global_setting_quick_order_label": "Đặt Lệnh Nhanh",
  "global_setting_title": "Cài Đặt Tùy Chỉnh (áp dụng cho Giao Ngay)",
  "hint": "Lưu ý",
  "innovateQuota": "Giới Hạn Khả Dụng",
  "kline": "Chart",
  "l_version_tip": "Vui lòng cập nhật ứng dụng Bybit của bạn lên phiên bản mới nhất để tham gia sự kiện Bybit Launchpad.",
  "LastTradedPrice": "Giá GD Cuối",
  "leverage": "Đòn Bẩy",
  "leverage_can_borrow": "Có Thể Vay",
  "leverage_can_deposit": "Ký Quỹ",
  "leverage_data": "Dữ Liệu Ký Quỹ",
  "leverage_forced_order": "Lệnh Thanh Lý",
  "leverage_go_trade": "Giao Dịch Ngay",
  "leverage_loan_limit": "Số Tiền Vay Tối Đa",
  "leverage_min_borrow": "Số Tiền Vay Tối Thiểu",
  "leverage_off_trade_tip": "Vui lòng bật đòn bẩy và sau đó giao dịch với đòn bẩy.",
  "leverage_yearly_rate": "Lãi Suất Hàng Năm",
  "leverageCloseErrInfo": "Thất Bại! Hãy hoàn thành tất cả các khoản phải trả trước khi tắt Giao Dịch Ký Quỹ.",
  "leverageCloseTips": "Failed to disable Margin Trading, as there are active Spot Margin orders in your account.",
  "leverageLoanTips": "Không thể hoàn tất thao tác này vì tỷ lệ sử dụng IM/MM của Tài Khoản Ký Quỹ Hợp Nhất đã vượt quá ngưỡng.",
  "leverageLP_banner_title": "Giao Dịch Ký Quỹ Giao Ngay Bybit",
  "leverageLP-banner-desc": "Đầu tư bằng các khoản đã vay để tăng tỷ lệ hoàn vốn",
  "leverageLP-faq-a1": "Để xem danh sách đầy đủ, vui lòng tham khảo <a href=\"{url}\" target=\"_blank\" > Danh Sách Tài Sản Đảm Bảo & Tài Sản Có Thể Vay (Giao Dịch Ký Quỹ). </a>",
  "leverageLP-faq-a10": "Vui lòng nhấp vào Lệnh → Lệnh Giao Ngay → Lịch Sử Hoàn Trả → Thanh Lý để xem dữ liệu giao dịch.",
  "leverageLP-faq-a11": "Vui lòng nhấp vào Lệnh → Lệnh Giao Ngay → Lịch Sử Hoàn Trả để xem lịch sử vay và trả.",
  "leverageLP-faq-a2": "Giao dịch ký quỹ trên Bybit phải chịu phí giao dịch Giao Ngay, lãi suất và phí đóng vị thế. Vui lòng tham khảo <a href=\"{url}\" target=\"_blank\" > Giao Dịch Ký Quỹ Giao Ngay Bybit : Hoa Hồng & Tổng Quan để biết chi tiết. </a>",
  "leverageLP-faq-a3": "Giao dịch ký quỹ sẽ yêu cầu ký quỹ tài sản tiền điện tử để vay trên tài khoản Giao Ngay Bybit.",
  "leverageLP-faq-a4": "Không. Bạn không đủ điều kiện để giao dịch đòn bẩy nếu có hoạt động Vay Tổ Chức. Nếu muốn xóa mã người dùng (UID) của mình khỏi danh sách người dùng Vay Tổ Chức, vui lòng gửi email tới sports_services{'@'}bybit.com để được hỗ trợ.",
  "leverageLP-faq-a5": "Lãi suất cho vay sẽ khác nhau dựa trên cấp VIP. Vui lòng xem <a href=\"{url}\" target=\"_blank\"> dữ liệu đòn bẩy để biết thêm chi tiết. </a>",
  "leverageLP-faq-a6": "Tiền lãi được tính theo giờ. Khoảng vay dưới một giờ cũng được tính là một giờ.",
  "leverageLP-faq-a7": "Bạn sẽ nhận được hai (2) thông báo rủi ro qua SMS và email:\n\n(1) Khi mức độ rủi ro của tài khoản Giao Ngay ≥ 87%, cảnh báo rủi ro sẽ được kích hoạt. Bạn sẽ nhận được thông báo qua SMS và email như một lời nhắc thêm tài sản đảm bảo (chuyển thêm tài sản đảm bảo) để tránh việc buộc phải đóng vị thế.\n\n(2) Khi mức độ rủi ro của tài khoản Giao Ngay ≥ 95%, bạn sẽ nhận được cảnh báo bắt buộc thanh lý qua SMS và email để thông báo rằng vị thế của bạn đã bị thanh lý.\n\nVui lòng tham khảo <a href=\"{url}\" target=\"_blank\"> Rủi Ro & Thanh Lý Bắt Buộc (Giao Dịch Giao Ngay Có Đòn Bẩy) để biết thêm chi tiết về quy trình và tiêu chí.</a>",
  "leverageLP-faq-a8": "Quỹ Bảo Hiểm Ký Quỹ (Margin Insurance Fund/MAF) bảo hiểm cho việc mất vị thế của một nhà giao dịch sau khi thực hiện thanh lý bắt buộc vị thế do không đủ tiền trong tài khoản, để hoàn trả khoản vay.\n\nNếu tài khoản Giao Ngay mất khả năng thanh toán, sàn sẽ sử dụng Quỹ Bảo Hiểm Ký Quỹ để trang trải khoản nợ của bạn. Do đó, một khoản phí thanh lý sẽ được thu để trang trải chi phí của Quỹ Bảo Hiểm Ký Quỹ.",
  "leverageLP-faq-a9": "Nếu vẫn còn bất kỳ khoản đã vay chưa thanh toán nào sau khi đã sử dụng ký quỹ để trả khoản vay, khoản lỗ còn lại sẽ được Quỹ Bảo Hiểm Ký Quỹ bảo hiểm.",
  "leverageLP-faq-q1": "Loại tiền điện tử nào có thể được sử dụng làm tài sản ký quỹ hoặc tài sản có thể vay trong giao dịch ký quỹ?",
  "leverageLP-faq-q10": "Tôi có thể xem lịch sử thanh lý ở đâu?",
  "leverageLP-faq-q11": "Tôi có thể xem lịch sử vay và trả ở đâu?",
  "leverageLP-faq-q2": "Có phát sinh phí hoa hồng trên giao dịch ký quỹ không?",
  "leverageLP-faq-q3": "Tôi nên sử dụng tài khoản Bybit nào khi giao dịch ký quỹ?",
  "leverageLP-faq-q4": "Tôi có thể giao dịch với ký quỹ hoặc đòn bẩy nếu đã kích hoạt Vay Tổ Chức không?",
  "leverageLP-faq-q5": "Lãi suất cho vay đối với Giao Dịch Ký Quỹ Bybit",
  "leverageLP-faq-q6": "Tiền lãi vay được tính bắt đầu từ lúc nào?",
  "leverageLP-faq-q7": "Tôi sẽ nhận được thông báo rủi ro Giao Dịch Ký Quỹ trong những trường hợp nào?",
  "leverageLP-faq-q8": "Quỹ Bảo Hiểm Ký Quỹ là gì?",
  "leverageLP-faq-q9": "Điều gì xảy ra nếu tôi không có đủ tiền trong tài khoản Giao Ngay trong trường hợp buộc phải thanh lý?",
  "leverageLP-faq-title": "Câu Hỏi Thường Gặp",
  "leverageLP-feature-title": "Tại Sao Nên Giao Dịch Ký Quỹ Giao Ngay?",
  "leverageLP-feature1": "Cấp số nhân lợi nhuận giao dịch",
  "leverageLP-feature2": "Hỗ trợ giao dịch vị thế long/short",
  "leverageLP-feature3": "Cải thiện hiệu quả sử dụng vốn",
  "leverageLP-feature4": "Đa dạng hóa tài sản",
  "leverageLP-whats-leverage": "Giao Dịch Ký Quỹ Giao Ngay Là Gì?",
  "leverageLP-whats-leverage-c": "Giao Dịch Ký Quỹ Giao Ngay Bybit là sản phẩm Phái Sinh của giao dịch Giao Ngay cho phép các nhà giao dịch vay và tận dụng tiền bằng cách ký quỹ tài sản tiền điện tử. Các khoản tiền đã vay sẽ được sử dụng để tăng lợi nhuận giao dịch trên vị thế đòn bẩy thành công trong các thị trường có độ biến động thấp hoặc cao.",
  "leverageTest": "Trắc Nghiệm Về Giao Dịch Ký Quỹ",
  "leverageTestSubTitle": "Bạn phải trả lời đúng tất cả các câu hỏi để bắt đầu Giao Dịch Ký Quỹ.",
  "leverageTryAgain": "Lỗi hệ thống. Vui lòng thử lại sau.",
  "liquidate": "Thanh Lý",
  "liquidationErrorInfo": "Không thành công! Đã kích hoạt thanh lý trên tài khoản.",
  "load_more": "Tải Thêm",
  "loan": "Vay",
  "loan_limit": "Thời Hạn Cho Vay",
  "loan_spot_account": "tài khoản Giao Ngay",
  "loanLualityDeposit1": "Bạn chỉ có thể giảm số tiền đảm bảo khi tỷ lệ LTV hiện tại thấp hơn LTV ban đầu. ",
  "loanLualityDeposit2": "Mức giảm tài sản đảm bảo tối đa là số tiền cần thiết để đưa tỷ lệ LTV trở lại mức ban đầu.",
  "loanLualityDeposit3": "Số tiền đảm bảo không thể giảm nếu giá trị số tiền giảm thấp hơn giá trị ký quỹ có thể điều chỉnh.",
  "loanTime": "Thời Gian",
  "login": "Đăng nhập",
  "lp_go_home": "Quay lại",
  "lpn_one_progress_info": "Dự kiến kết quả sẽ có trong",
  "lpn_order_btn": "Đăng ký của tôi",
  "lpn_order_btn_cancel": "Hủy",
  "lpn_order_btn_confirm": "Xác Nhận",
  "lpn_order_submit_error": "Thất Bại",
  "lpn_order_submit_error_desc": "Lỗi hệ thống. Vui lòng thử lại sau.",
  "lpn_unfold": "Thêm",
  "lt_all": "Tất cả",
  "lt_amount": "Số tiền",
  "lt_amount_not_enough": "Số dư {currency} có sẵn không đủ!",
  "lt_entry_tips": "Hỗ trợ giao dịch Token Đòn Bẩy cho {symbol} ({direction}). Giao dịch ngay!",
  "lt_freerate": "Mức phí",
  "lt_lowcase_redemption": "nhận lại",
  "lt_lowcase_subscription": "đăng ký",
  "lt_open_success_txt": "Chúc mừng, bạn đã kích hoạt thành công Token Đòn Bẩy!",
  "lt_orders_submitted": "Đã gửi thành công lệnh {ordertype} với số lượng {quantity} của bạn.",
  "lt_redemption": "Quy Đổi",
  "lt_redemption_failed_change_position": "Tái cân bằng đã được kích hoạt cho cặp đã chọn và quy đổi hiện không được hỗ trợ. Vui lòng thử lại sau.",
  "lt_redemption_failed_closed": "Quy đổi hiện không được hỗ trợ cho tài sản đã chọn. Vui lòng thử lại sau.",
  "lt_redemption_failed_input_quantity": "Vui lòng nhập số tiền nhận lại",
  "lt_redemption_failed_net_worth": "Giá trị tài sản ròng không hợp lệ và quy đổi hiện không được hỗ trợ. Vui lòng thử lại sau.",
  "lt_redemption_failed_wear_position": "Tài khoản của bạn đang được thanh lý và quy đổi hiện không được hỗ trợ. Vui lòng thử lại sau.",
  "lt_redemption_max_quanlity": "Số lượng quy đổi tối đa trên mỗi giao dịch cho tài sản đã chọn không được thấp hơn {quantity}.",
  "lt_redemption_min_quanlity": "Số lượng quy đổi tối thiểu trên mỗi giao dịch cho tài sản đã chọn không được cao hơn {quantity}.",
  "lt_redemption_tips": "Số tiền quy đổi thực tế có thể thay đổi đôi chút.",
  "lt_subscription": "Đăng Ký",
  "lt_subscription_failed_change_position": "Tái cân bằng đã được kích hoạt cho cặp đã chọn và đăng ký hiện không được hỗ trợ. Vui lòng thử lại sau.",
  "lt_subscription_failed_close_position": "Tài khoản của bạn đang được thanh lý và đăng ký hiện không được hỗ trợ. Vui lòng thử lại sau.",
  "lt_subscription_failed_closed": "Đăng ký hiện không được hỗ trợ cho tài sản đã chọn. Vui lòng thử lại sau.",
  "lt_subscription_failed_input_amount": "Vui lòng nhập số tiền đăng ký",
  "lt_subscription_failed_invalid_value": "Giá trị tài sản ròng không hợp lệ và đăng ký hiện không được hỗ trợ. Vui lòng thử lại sau.",
  "lt_subscription_failed_large_amount": "Số tiền đăng ký của bạn quá lớn và mức rủi ro của bạn sẽ tăng. Có thể có rủi ro thanh lý.",
  "lt_subscription_failed_wear_position": "Tài khoản của bạn đang có vốn chủ sở hữu âm và đăng ký hiện không được hỗ trợ. Vui lòng thử lại sau.",
  "lt_subscription_max_amount": "Số tiền đăng ký tối đa trên mỗi giao dịch cho tài sản đã chọn không được cao hơn {amount}.",
  "lt_subscription_min_amount": "Số tiền đăng ký tối thiểu trên mỗi giao dịch cho tài sản đã chọn không được thấp hơn {amount}.",
  "lt_subscription_redemption": "Đăng Ký Và Quy Đổi",
  "lt_subscription_redemption_records": "Lịch sử đăng ký và quy đổi",
  "lt_subscription_tips": "Số tiền đăng ký thực tế có thể thay đổi đôi chút.",
  "lt_subscription_usdt_not_enough": "Số dư USDT có sẵn không đủ! Vui lòng nạp hoặc chuyển tiền trước.",
  "lt-landing-banner-desc": "Đòn Bẩy Không Rủi Ro Thanh Lý",
  "lt-landing-banner-title": "Token Đòn Bẩy Bybit",
  "lt-landing-faq-a1": "NAV, hay giá trị tài sản ròng, đề cập đến giá trị của Token Đòn Bẩy. NAV của Token Đòn Bẩy di chuyển phù hợp với biến động giá thị trường của hợp đồng vĩnh viễn.",
  "lt-landing-faq-a2": "Sử dụng BTC làm ví dụ,\n\nBTC3L đề cập đến Token Đòn Bẩy nắm giữ các vị thế long của hợp đồng BTCUSDT vĩnh viễn với đòn bẩy 3x.\n\nBTC3S đề cập đến Token Đòn Bẩy nắm giữ các vị thế short của hợp đồng BTCUSDT vĩnh viễn với đòn bẩy 3x.",
  "lt-landing-faq-a3": "Giao dịch Token Đòn Bẩy sẽ được chuyển trực tiếp qua tài khoản Giao Ngay.",
  "lt-landing-faq-a4": "Vui lòng tham khảo <a href=\"{url}\" target=\"_blank\">Sự khác biệt giữa Token Đòn Bẩy và Giao Dịch Phái Sinh</a>.",
  "lt-landing-faq-a5": "Vui lòng tham khảo <a href=\"{url}\" target=\"_blank\">Token Đòn Bẩy Bybit: Giải Thích Phí</a>.",
  "lt-landing-faq-a6": "Không có rủi ro thanh lý.\n\nLấy BTC3L làm ví dụ, phạm vi đòn bẩy mục tiêu là [2,4]. Cơ chế tái cân bằng sẽ tự động được kích hoạt khi tỷ lệ đòn bẩy thực tế ≥ 4x hoặc ≤ 2x, được điều chỉnh để đạt được đòn bẩy mục tiêu là 3x.\n\nLưu ý: Giá trị tài sản ròng của Token Đòn Bẩy có thể giảm xuống 0; trong trường hợp này, NAV sẽ không thể khôi phục được.",
  "lt-landing-faq-a7": "Tái cân bằng là quá trình đảm bảo rằng các vị thế hợp đồng vĩnh viễn của tài sản cơ sở sẽ được điều chỉnh động để đạt được đòn bẩy mục tiêu. Cơ chế tái cân bằng sẽ tự động được kích hoạt khi tỷ lệ đòn bẩy thực tế nằm ngoài phạm vi đòn bẩy mục tiêu.\n\nĐể biết thêm thông tin, vui lòng tham khảo <a href=\"{url}\" target=\"_blank\">Cơ Chế Tái Cân Bằng Token Đòn Bẩy Bybit</a>.",
  "lt-landing-faq-a8": "Hiện chưa hỗ trợ rút Token Đòn Bẩy.",
  "lt-landing-faq-q1": "Giá trị tài sản ròng (NAV) là gì?",
  "lt-landing-faq-q2": "Ký hiệu của Token Đòn Bẩy đại diện cho điều gì?",
  "lt-landing-faq-q3": "Tôi có thể sử dụng tài khoản nào để giao dịch Token Đòn Bẩy trên Bybit?",
  "lt-landing-faq-q4": "Sự khác biệt giữa Token Đòn Bẩy và Giao Dịch Phái Sinh là gì?",
  "lt-landing-faq-q5": "Các khoản phí liên quan đến Token Đòn Bẩy",
  "lt-landing-faq-q6": "Các vị thế Token Đòn Bẩy sẽ bị thanh lý trong những trường hợp nào?",
  "lt-landing-faq-q7": "Cơ chế tái cân bằng là gì?",
  "lt-landing-faq-q8": "Có thể rút Token Đòn Bẩy không?",
  "lt-landing-faq-title": "Câu Hỏi Thuờng Gặp",
  "lt-landing-feature-title": "Ưu Điểm Của Token Đòn Bẩy",
  "lt-landing-feature1": "Tăng lợi nhuận thông qua đòn bẩy",
  "lt-landing-feature2": "Không có rủi ro thanh lý",
  "lt-landing-feature3": "Tối ưu sử dụng vốn",
  "lt-landing-feature4": "Giao dịch dễ dàng",
  "lt-landing-learn-more": "Tìm Hiểu Thêm",
  "lt-landing-operation": "Thao Tác",
  "lt-landing-symbol": "Cặp Giao Dịch",
  "lt-landing-whats-lt": "Token Đòn Bẩy là gì?",
  "lt-landing-whats-lt-c": "Token Đòn Bẩy là sản phẩm phái sinh cung cấp tỷ lệ đòn bẩy cho tài sản cơ sở không yêu cầu ký quỹ, có thể tăng lợi nhuận và không có rủi ro thanh lý.\n\nMỗi Token Đòn Bẩy đại diện cho một rổ các vị thế hợp đồng vĩnh viễn.\n\nGiá trị tài sản ròng (NAV) của Token Đòn Bẩy di chuyển phù hợp với biến động giá thị trường của hợp đồng vĩnh viễn.",
  "lt-learning-video-title": "Video hướng dẫn người mới bắt đầu về token đòn bẩy",
  "ltLearningVideo": "Video Hướng Dẫn",
  "ltNav": "Tài Sản Ròng",
  "ltOpenRiskContent": "Token Đòn Bẩy mang đến cho bạn cơ hội sử dụng đòn bẩy trên tài sản cơ sở\n\nBybit có quyền sửa đổi Điều Khoản Dịch Vụ và thực hiện bất kỳ động thái nào sau đây dựa trên điều kiện thị trường mà không cần thông báo trước cho người dùng:\n\n1. Xóa bất kỳ Token Đòn Bẩy.\n\n2. Thêm hoặc điều chỉnh các hạn chế, như giới hạn số lượng vị thế. Vui lòng truy cập Blog của chúng tôi để biết chi tiết nếu có thay đổi. Trong trường hợp giới hạn số lượng vị thế, số lượng thực tế bạn có thể truy cập có thể thay đổi so với số lượng được công bố chính thức do các vấn đề kỹ thuật. Vui lòng lưu ý những rủi ro liên quan.\n\n3. Điều chỉnh động vị thế của tài sản cơ sở để đạt được đòn bẩy mục tiêu.\n\n4. Loại bỏ bất kỳ điều khoản trong Điều Khoản Dịch Vụ.\n\nVui lòng đảm bảo bạn hiểu đầy đủ về Token Đòn Bẩy như một sản phẩm tài chính và đầu tư hợp lý dựa trên mức độ chấp nhận rủi ro và trình độ chuyên môn. Bybit sẽ không chịu trách nhiệm về bất kỳ tổn thất và rủi ro nào liên quan đến giao dịch Token Đòn Bẩy.\n\nBằng cách tiếp tục, bạn cũng đồng ý với <a href={url} target=\"_blank\">Điều Khoản Dịch Vụ</a>về giao dịch Token Đòn Bẩy.",
  "ltOpenRiskSubmit": "Đồng Ý & Bật Token Đòn Bẩy",
  "ltOpenRiskTitle": "Thỏa Thuận Dịch Vụ Token Đòn Bẩy",
  "ltTestDialogContent": "Bạn có chắc chắn muốn thoát bài trắc nghiệm không? Câu trả lời của bạn sẽ không được lưu.",
  "ltTestDialogContinue": "Không",
  "ltTestDialogExit": "Có",
  "ltTestDialogTitle": "Xác Nhận",
  "ltTestDone": "Bạn đã trả lời <span>{num}/{numAll}</span> câu hỏi",
  "ltTestDoneFail": "Rất tiếc, bạn chỉ trả lời đúng {num}/{numAll} câu hỏi! Vui lòng làm lại.",
  "ltTestPassContent": "Chúc mừng, bạn đã vượt qua bài trắc nghiệm!",
  "ltTestPassRead": "Đọc Thêm",
  "ltTestPassReject": "Bỏ Qua",
  "ltTestResubmit": "Vui lòng thử lại",
  "ltTestSubmit": "Gửi Ngay",
  "ltTestSubTitle": "Bạn phải trả lời chính xác tất cả các câu hỏi để bắt đầu giao dịch Token Đòn Bẩy.",
  "ltTestTitle": "Trắc Nghiệm",
  "ltUnderlying": "Cơ Sở",
  "margin_coin": "Coin",
  "margin_discount": "Hệ Số",
  "margin_discount_eg": "Ví dụ:",
  "margin_discount_eg_body": "Giả sử nhà giao dịch A có 1 BTC, 1000 BIT và 100 TRX trong tài khoản Giao Ngay.\nGiả sử giá thị trường của BTC, BIT và TRX lần lượt là 50.000 USDT, 5 USDT và 0,50 USDT, tổng giá trị tài sản đảm bảo cho Giao Dịch Ký Quỹ sẽ là:\n(1 (Số lượng) * 50000 (Giá) * 1 (Hệ số) * 1) + (1.000 (Số lượng) * 5 (Giá) * 0.9 (Hệ số) + (100 (Số lượng) * 0.5 (Giá) * 0 (Hệ số) = 54.500 USDT.",
  "margin_discount_rate": "Thông Số Ký Quỹ",
  "margin_lq_order": "Lệnh Thanh Lý",
  "MARKET": "Giá thị trường",
  "max": "Tối Đa",
  "more": "Thêm",
  "network_error": "Yêu cầu không thành công. Vui lòng thử lại sau.",
  "NEW": "Mở",
  "nextPage": "Trang sau",
  "nodata": "Không thấy dữ liệu",
  "none": "Không có",
  "noRecordFound": "Không tìm thấy dữ liệu",
  "og_description": "Mua, bán và giao dịch {symbol} an toàn với giao dịch Giao Ngay. Giao dịch tự tin và tận hưởng mức phí thấp và thanh khoản sâu.",
  "og_title": "{symbol} {'|'} Mua, Bán & Giao Dịch Với Phí Thấp {'|'} Giao Ngay",
  "ol_agree": "Tôi đã đọc và đồng ý",
  "ol_agrmt": "Thỏa Thuận Cho Vay Tài Sản Kỹ Thuật Số",
  "ol_agrmt_2": "<Thỏa Thuận Cho Vay Tài Sản Kỹ Thuật Số>",
  "ol_agrmt_err": "Thỏa Thuận Cho Vay Tài Sản Kỹ Thuật Số phải được ký.",
  "ol_amt": "Khoản vay",
  "ol_amt_err": "Số tiền vay {condition} là {amount} {unit}",
  "ol_amt_tip": "Vui lòng nhập số tiền vay của bạn",
  "ol_app_sub": "Đơn vay đã được nộp",
  "ol_app_time": "Thời gian nộp đơn",
  "ol_apply_title": "Đơn đăng ký trực tuyến Cho Vay OTC",
  "ol_cancel": "Bạn có chắc muốn bỏ đơn này không?",
  "ol_cfm_product": "Sản phẩm Cho Vay OTC",
  "ol_check_app": "Kiểm tra đơn của bạn",
  "ol_coin": "Coin",
  "ol_col_amt": "Số lượng",
  "ol_col_app_tm": "Thời gian nộp đơn",
  "ol_col_dl": "Thời hạn cho vay",
  "ol_col_no": "Số lệnh",
  "ol_col_pn": "Tên sản phẩm",
  "ol_col_sub": "Các tài khoản phụ",
  "ol_confirm": "Xác Nhận Đơn Vay",
  "ol_contact_desc": "Vui lòng đảm bảo rằng thông tin đã được cập nhật và hợp lệ, vì tất cả các cảnh báo rủi ro sẽ được gửi đến địa chỉ email và điện thoại di động của bạn.",
  "ol_contact_tip": "Vui lòng liên hệ với nhóm Phát Triển Kinh Doanh",
  "ol_contact_title": "Chi tiết liên hệ",
  "ol_detail_title": "Chi tiết đơn vay",
  "ol_eg": "Ví dụ",
  "ol_email": "Địa chỉ email",
  "ol_email_err_invalid": "Địa chỉ email không hợp lệ",
  "ol_email_tip": "Vui lòng nhập địa chỉ email của bạn",
  "ol_max": "maximum",
  "ol_mgr": "ID đại diện quản lý của bạn",
  "ol_mgr_err_invalid": "ID không hợp lệ",
  "ol_mgr_link": "Nhấp để lấy ID đại diện quản lý của bạn",
  "ol_mgr_tip": "Vui lòng nhập ID đại diện quản lý của bạn",
  "ol_min": "minimum",
  "ol_mine_title": "Đơn vay của tôi",
  "ol_month": "{month} tháng",
  "ol_no_code_rcd": "Không tìm thấy mã quốc gia",
  "ol_notice_desc": "<li>Cho Vay OTC chỉ khả dụng cho các nhà giao dịch tổ chức.</li>\n<li>Các nhà giao dịch tổ chức đăng ký khoản vay phải có tài sản ít nhất 500.000 USDT.</li>\n<li>Các khoản vay có thể được sử dụng trên thị trường Giao Ngay hoặc Phái Sinh, tùy vào sản phẩm được chọn.</li>",
  "ol_notice_desc_lmt": "<li>Khoản vay tối thiểu là 1.000.000 USDT và tối đa là 20.000.000 USDT.</li>",
  "ol_notice_title": "Hướng dẫn Cho Vay OTC",
  "ol_phone": "Số điện thoại",
  "ol_phone_err": "Vui lòng chọn mã vùng và nhập số điện thoại di động của bạn",
  "ol_phone_err_invalid": "Số điện thoại di động không hợp lệ",
  "ol_phone_tip": "Vui lòng nhập số điện thoại di động của bạn",
  "ol_prd": "Vui lòng chọn một sản phẩm Cho Vay OTC",
  "ol_prd_3x_spot": "Vay Tổ Chức: Đòn Bẩy 3x (Giao Ngay)",
  "ol_prd_3x_spot_futures": "Vay Tổ Chức: Đòn Bẩy 3x (Giao Ngay & Phái Sinh)",
  "ol_prd_5x_spot": "Vay Tổ Chức: Đòn Bẩy 5x (Giao Ngay)",
  "ol_prd_link": "Tìm hiểu thêm về sản phẩm",
  "ol_prd_tip": "Nếu chuyển đổi tài sản trong tài khoản giao ngay sang tài sản không ký quỹ, rủi ro thanh lý sẽ tăng lên. Để biết chi tiết về các tài sản ký quỹ được hỗ trợ trên thị trường Giao Ngay của Bybit, vui lòng nhấp vào <a href={url} target=\"_blank\">đây</a>.",
  "ol_recent_year_only": "Kết quả tìm kiếm chỉ bao gồm các đơn vay của năm gần đây nhất.",
  "ol_status": "Trạng thái đơn",
  "ol_status_list": "Tất cả, Đã xét, Đã nhận đơn, Từ chối, Đã giải ngân",
  "ol_subacc": "Thêm (các) tài khoản phụ",
  "ol_subacc_tip": "Vui lòng nhập mã người dùng của (các) tài khoản phụ bạn muốn thêm. Nếu cần thêm nhiều tài khoản phụ, vui lòng liên hệ với nhóm Phát Triển Kinh Doanh của chúng tôi.",
  "ol_term": "Thời hạn cho vay",
  "ol_term_err": "Vui lòng chọn thời hạn của đơn vay.",
  "ol_unit_month": "Đơn vị: Tháng",
  "ol_view_agrmt": "Xem tệp Thỏa Thuận đính kèm",
  "operationSuccess": "Thành công",
  "or": "hoặc",
  "orderBook": "Sổ lệnh",
  "orderHistory": "Lịch sử lệnh",
  "orderId": "Mã Lệnh",
  "orderSuccessful": "Gửi lệnh thành công!",
  "orderType": "Loại Lệnh",
  "otcErrorInfo": "Rất tiếc, bạn đã kích hoạt Vay Tổ Chức và không còn đủ điều kiện tham gia Giao Dịch Ký Quỹ.",
  "outstanding": "Chưa Trả",
  "pa_accumated_profit_descript": "Lợi nhuận tích lũy là tổng lợi nhuận được tạo ra mỗi ngày trong một khoảng thời gian nhất định. Biểu đồ chỉ hiển thị dữ liệu của ngày hôm trước.",
  "pa_accumated_profit_select": "Lợi Nhuận Tích Luỹ Thực Tế",
  "pa_accumated_profit_title": "Lợi Nhuận Tích Luỹ",
  "pa_accumulated_account": "ROI Tích Luỹ Của Tài Khoản Giao Ngay",
  "pa_accumulated_btc": "Thay Đổi Giá Tích Luỹ Của BTC (%)",
  "pa_accumulated_btc_select": "Thay Đổi Giá Tích Luỹ Thực Tế Của BTC (%)",
  "pa_accumulated_pnl": "P&L 7 Ngày",
  "pa_accumulated_pnl_select": "ROI Tích Luỹ Thực Tế",
  "pa_accumulated_roi_descript": "ROI tích lũy đánh giá hiệu quả lợi nhuận tạo ra trên một khoản đầu tư trong một khoảng thời gian nhất định. Biểu đồ chỉ hiển thị dữ liệu của ngày hôm trước.",
  "pa_accumulated_roi_title": "ROI Tích Luỹ",
  "pa_assets_distribution_descript": "Phân bổ tài sản là tỷ trọng của từng tài sản trong Tài Khoản Giao Ngay so với tổng giá trị của tất cả tài sản tính bằng USDT.",
  "pa_assets_distribution_title": "Phân Phối Tài Sản",
  "pa_daily_pnl": "P&L Hôm Nay",
  "pa_daily_profit_descript": "Biểu đồ P&L hàng ngày chỉ hiển thị dữ liệu của ngày hôm trước.",
  "pa_daily_profit_select": "P&L Trong Ngày",
  "pa_daily_profit_title": "P&L Hàng Ngày",
  "pa_last_30_day": "30 ngày trước",
  "pa_last_7_day": "7 ngày trước",
  "pa_last_90_day": "90 ngày trước",
  "pa_others": "Khác",
  "pa_page_description": "Luôn cập nhật về hiệu suất của danh mục Giao Ngay và điều chỉnh chiến lược đầu tư theo những thay đổi của thị trường trong thời gian thực.",
  "pa_page_title": "Phân Tích P&L Tài Sản Giao Ngay",
  "pa_quantity": "Số lượng {Coin}",
  "pa_spot_pnl_descript": "1. Dữ liệu P&L Giao Ngay sẽ được cập nhật lúc 7:00 (giờ Việt Nam) mỗi ngày.\n2. Dữ liệu P&L Giao Ngay mới nhất sẽ được tính từ 7:00 đến 13:00 (giờ Việt Nam) và sẽ được hiển thị sau 11:00 (giờ Việt Nam) mỗi ngày.",
  "pa_spot_pnl_title": "Phân Tích P&L Giao Ngay",
  "pa_total_assets": "Tổng Tài Sản",
  "pa_total_assets_value_descript": "Tổng giá trị tài sản đề cập đến tổng giá trị của tất cả tài sản trong Tài Khoản Giao Ngay (bao gồm cả tài sản vay) và sẽ bị ảnh hưởng bởi việc rút tiền, chuyển khoản (vào và ra), các khoản vay và vị thế ký quỹ.",
  "pa_total_assets_value_select": "Giá Trị Tài Sản",
  "pa_total_assets_value_title": "Tổng Giá Trị Tài Sản",
  "pa_update_on": "Cập nhật lần cuối:",
  "pa_value": "Giá trị {Coin}",
  "pa_weightage": "Tỷ trọng {Coin}",
  "pauseTradeTip": "{symbol} tạm thời chưa sẵn sàng. Để biết thêm thông tin, vui lòng truy cập<a href={url} target=\"_blank\">blog của chúng tôi</a>.",
  "placeHolder": "Chọn",
  "prevPage": "Trang trước",
  "price": "Giá",
  "quantity": "Số Lượng",
  "ReduceLoan": "Giảm Xuống",
  "ReduceLoanAssets": "Giảm Số Tiền Đảm Bảo",
  "ReduceLoanTip1": "Số tiền đảm bảo không thể giảm trừ khi tỷ lệ LTV hiện tại thấp hơn LTV ban đầu.  ",
  "ReduceLoanTip2": "Số tiền đảm bảo không thể giảm trừ khi giá trị số tiền giảm thấp hơn giá trị ký quỹ có thể điều chỉnh.",
  "ReduceLoanTip3": "Số tiền đảm bảo không thể giảm nếu tỷ lệ LTV hiện tại đáp ứng hoặc vượt quá tỷ lệ LTV ban đầu. Vui lòng thử lại. ",
  "ReduceLoanTip4": "Bạn có thể quản lý số tiền đảm bảo trên trang Đặt lệnh. Bạn có thể tăng tài sản đảm bảo bất cứ lúc nào và chỉ giảm khi tỷ lệ LTV hiện tại thấp hơn LTV ban đầu. ",
  "repayment": "Trả",
  "reset": "Đặt lại",
  "reverse_contract_account": "tài khoản Phái Sinh Nghịch Đảo",
  "riskWarning": "Xác nhận rủi ro",
  "search": "Tìm kiếm",
  "side": "Hướng",
  "signup": "Đăng ký",
  "spot_account": "Tài Khoản Giao Ngay",
  "status": "Trạng thái",
  "stop_limit": "TP/SL",
  "stop_limit_tips_2": "Không thể kích hoạt Giao Dịch Ký Quỹ nếu bạn có lệnh Chốt Lời hoặc Cắt Lỗ.",
  "success": "Thành Công",
  "sure": "đồng ý",
  "tests1": "",
  "times": "lần",
  "timestamp": "Dấu thời gian",
  "title_404": "404 {'|'} Giao dịch Giao ngay Bybit  ",
  "to": "đến",
  "toastTheSymbolNotExist": "Rất tiếc, cặp Giao Ngay bạn chọn hiện không sẵn sàng để giao dịch.",
  "total": "Tổng số",
  "tradeChange": "% Thay Đổi",
  "tradeId": "Mã Giao Dịch",
  "transfer": "Chuyển",
  "usdc_contract_account": "tài khoản USDC Phái Sinh",
  "VIP99": "Supreme VIP",
  "volume": "Số Lượng Khớp",
  "vote_btn_trade": "Giao Dịch"
}